<template>
  <WdsStack gap-xs align-center justify-space-between class="tw-max-w-[200px] job-owners-column">
    <WdsText :text="mainOwner" />
    <WdsTooltip v-if="column.owners.length > 1" global>
      <template #tooltip-content>
        <span v-for="(owner, index) in column.owners" :key="owner.id">
          {{ `${owner.name}${index < column.owners.length - 1 ? ',' : ''}` }}
          <br />
        </span>
      </template>
      <WdsLabel sm class="tw-whitespace-nowrap">+ {{ column.owners.length - 1 }}</WdsLabel>
    </WdsTooltip>
  </WdsStack>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsLabel, WdsStack, WdsText, WdsTooltip } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const JobOwnersColumn = graphql(`
  fragment JobOwnersColumn on Job {
    id
    owners {
      id
      name
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof JobOwnersColumn>
}>()

const column = computed(() => useFragment(JobOwnersColumn, props.row))
const mainOwner = computed(() => column.value.owners[0]?.name ?? $t('No job owner'))
</script>

<style lang="scss">
.job-owners-column {
  .wds-text {
    @apply tw-truncate;
    .wds-text-primary {
      @apply tw-truncate;
    }
  }
}
</style>
